import React from 'react';
import { Image } from 'react-konva';
import useImage from 'use-image';

interface IBlueprintImage {
  image: string;
}

export const BlueprintImage = ({ image }: IBlueprintImage) => {
  // console.log('image', image);
  const [ init ] = useImage(image);
  return <Image image={init} />;
};
